/* 🤖 this file was generated by script */
export const wiconSignaturePen = {
  name: 'signature_pen',
  data: `<svg viewBox="0 0 20 20"><path fill="currentColor" stroke="currentColor" stroke-width="1.5" d="M12.88 2.85a1.2 1.2 0 011.7 0v0a1.2 1.2 0 010 1.7l-8.61 8.6-2.12.43.42-2.12 8.6-8.61z"/><path fill="none" stroke="currentColor" stroke-linecap="round" d="M3 14.9c2.53 2.52 15.04 4.8 7.97 1.43-5.94-2.82 2.21-.92 7.07.69"/></svg>`,
};
